import { call, put, takeEvery, select } from 'redux-saga/effects';
import { checkHasContractLog } from 'store/auth/selectors';
import DisplayItemsService from 'domain/settings/DisplayItemsService';
import types from './types';
import actions from './actions';

function* fetch(action) {
  try {
    const { funcId, displayitemsApi } = action.payload;
    const hasContractLog = yield select(checkHasContractLog);
    yield put(actions.requestStart());
    const {
      data: { data },
    } = yield call(displayitemsApi.fetch, funcId);
    const { items, sorting } = DisplayItemsService.getItemsByContractLog(
      funcId,
      data,
      hasContractLog
    );

    yield put(
      actions.fetchSucceeded({
        override: true,
        funcId,
        items,
        sorting,
      })
    );
  } catch (error) {
    const { funcId } = action.payload;
    yield put(actions.requestFailed({ error }));
  }
}

function* create(action) {
  const { funcId, data, displayitemsApi } = action.payload;
  try {
    yield put(actions.requestStart());
    const {
      data: { data: csvSetting },
    } = yield call(displayitemsApi.create, funcId, data);
    const { __sorting__: sorting = [], ...modalItems } = csvSetting;
    yield put(actions.createSucceeded(modalItems, sorting));
  } catch (error) {
    yield put(actions.requestFailed({ error }));
  }
}

export default function* watchView() {
  yield takeEvery(types.FETCH, fetch);
  yield takeEvery(types.CREATE, create);
}
